import React from 'react';

import { Button, usePermissions } from 'react-admin';

import {
  Box,
  Typography,
} from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';
import actions, { Actions } from '../../constants/actions';
import hasAccess from '../../utilities/hasAccess';

const ConflictVerifiedStatus = ({
  selected,
  otherSelected,
  toMarkVerified,
} : {
  selected: boolean;
  otherSelected: boolean;
  toMarkVerified: string;
}) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <>
      {!selected && hasAccess(permissions, actions.DATA_POINT_UPDATE) && (
        <Button
          component={Link}
          variant={otherSelected ? 'outlined' : 'contained'}
          to={toMarkVerified}
          label="Mark as verified"
          size="medium"
        />
      )}
      {selected && (
        <Box display="flex" alignItems="center" gap={1}>
          <CheckIcon color="secondary" />
          <Typography color="secondary">Verified</Typography>
        </Box>
      )}
    </>
  );
};

export default ConflictVerifiedStatus;
